// extracted by mini-css-extract-plugin
export var publicationsReportsList = "index-module--publicationsReportsList--TaNdE";
export var publicationsReportsListItem = "index-module--publicationsReportsListItem--irc0j";